import { TranslationController } from './TranslationController';
import localTranslationBundles from './bundles/translationBundle.json';

/**
 * A service to help control translations throughout the website.
 */
export const translationService = new TranslationController( {
    /**
     * The key of the project stored in CMX. This is used to retrieve the
     * translations for the proper project.
     */
    projectKey: 'hoya-learning',

    /**
     * Local translation bundles to attempt to use as a fallback if translations
     * can't be retrieved from CMX for some reason.
     */
    localTranslationBundles: localTranslationBundles,

    /**
     * Attempt to fetch and store a language bundle after initialization.
     */
    attemptFetch: false,
} );
